/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { InAppPageRule, InAppPlatform, RuleOperator } from 'cio/utils/in-app/message-config';
import { action } from '@ember/object';

interface PageRuleArgs {
  rules: InAppPageRule[];
  onChange: (rules: InAppPageRule[]) => unknown;
}

export default class PageRule extends Component<PageRuleArgs> {
  constructor(owner: unknown, args: PageRuleArgs) {
    super(owner, args);
  }

  get hasAnyPageRules() {
    return this.args.rules.length > 0;
  }

  @action
  addNewRule() {
    let newRule = new InAppPageRule();
    this.args.onChange([...this.args.rules, newRule]);
  }

  @action
  setRule(index: number, operator: RuleOperator, value: string, platform: InAppPlatform) {
    if (index < 0 || index >= this.args.rules.length) {
      return;
    }

    let rules = [...this.args.rules];
    let rule = rules[index];
    rule.operator = operator;
    rule.value = value;
    rule.platform = platform;
    this.args.onChange(rules);
  }

  @action
  deleteRule(index: number) {
    if (index < 0 || index >= this.args.rules.length) {
      return;
    }

    let rules = [...this.args.rules];
    rules.splice(index, 1);
    this.args.onChange(rules);
  }
}
